export default "__VITE_ASSET__DY0JSXLf__"